import { RestUnitSummaryModel } from '@shared/interfaces/unit.interface';
import { RestUserModel } from '@shared/interfaces/user.interface';

export interface RestInspectionCreateModel {
  inspectionTemplateId: number;
  unitId: number;
  assignee: number;
  dueDate: Date;
  notifyAssignee: boolean;
  turboMode: boolean;
}

export interface RestInspectionsModel {
  id: number;
  inspectionTemplateId: number;
  unitId: number;
  unit: RestUnitSummaryModel;
  assignee: number;
  assigneeUser: RestUserModel;
  status: InspectionStatus;
  inspectionContents?: RestInspectionContents[];
  completedAt: Date;
  modifiedAt: Date;
  createdAt: Date;
  dueDate: Date;
  calendarPosition: number;
  inspectionType: InspectionType;
  isTurboMode?: boolean;
  attachments?: {
    attachment?: RestTypedInspectionAttachment;
    none: RestTypedInspectionAttachment[];
  };
  totalRooms?: number;
  completedRooms?: number;
}

export interface RestTypedInspectionAttachment {
  id: number;
  dateCreated: string;
  dateUpdated: string;
  isActive: boolean;
  fileUploadId: number;
  internalName: string;
  originalFileName: string;
  size: number;
  url: string;
  attachmentTypeUrn: string;
  title: string;
  description: string;
  externalUrl: string;
  inspectionAttachmentType: number;
  trueType: number;
}

export interface RestInspectionContents {
  id: number;
  inspectionId: number;
  inspectionTemplateAreaId: number;
  sharedInspectionLibrarySpaceId: number;
  status: InspectionItemStatus;
  surveyJSON: string;
  answerJSON: string;
  inspectionTemplateAreaTitle: string;
  sharedInspectionLibrarySpaceTitle?: string;
}

export interface SendInspectionReportRequest {
  to: string[];
  subject: string;
  mody: string;
}

export enum InspectionStatus {
  NotStarted,
  InProgress,
  Completed,
  Cancelled,
}

export enum InspectionItemStatus {
  Incompleted,
  Skipped,
  Completed,
}

export enum InspectionType {
  MoveOutVacant,
  Annual,
  MaintenanceCheck,
  MoveIn,
  CustomInspection,
  Periodic,
  MoveOutOccupied,
  Diligence,
}
